import history from '@/history';
import { formatQueryObj } from '@/common/utils';

/**
 * 单页路由跳转，history是react-router的history
 *
 * @param history
 * @param pathname
 * @param queryObj
 * @param ispush
 */
function _goto(pathname = '', queryObj: any, ispush = true /* true: push, false: replace */) {
  pathname = pathname || window.location.pathname;

  let query = '';
  if (queryObj && typeof queryObj === 'object') {
    query = formatQueryObj(queryObj);
  } else {
    query = queryObj;
  }
  if (query.length) query = '?' + query;

  const href = pathname + query;

  if (!history) {
    window.location.href = href;
    return;
  }

  if (ispush) {
    history.push(href);
  } else {
    history.replace(href);
  }
}

function prev() {
  history.go(-1);
}

function next() {
  history.go(1);
}

export { prev, next };

export default _goto;
